var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "portal",
    { attrs: { to: "app" } },
    [
      _c(
        "modal",
        {
          attrs: {
            name: "table-configurator",
            width: 480,
            height: "auto",
            scrollable: true
          }
        },
        [
          _c(
            "fup-modal-constructor",
            {
              attrs: { title: "Настройка таблицы", icon: "wrench" },
              on: { close: _vm.closeTableConfigurator }
            },
            [
              _c(
                "template",
                { slot: "default" },
                [
                  _vm.tableFields
                    ? [
                        _c("h3", [_vm._v("Колонки таблицы")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "Вы можете отключить ненужные колонки и изменить их порядок"
                          )
                        ]),
                        _vm._v(" "),
                        _vm.configuredTableFields && _vm.configuratorModal
                          ? _c(
                              "fup-draggable",
                              {
                                staticClass: "list-group",
                                attrs: { tag: "ul", handle: ".handle" },
                                on: { change: _vm.saveTableConfig },
                                model: {
                                  value: _vm.configuredTableFields,
                                  callback: function($$v) {
                                    _vm.configuredTableFields = $$v
                                  },
                                  expression: "configuredTableFields"
                                }
                              },
                              _vm._l(_vm.configuredTableFields, function(
                                element,
                                idx
                              ) {
                                return _c(
                                  "li",
                                  {
                                    key: element.key,
                                    staticClass: "list-group-item",
                                    attrs: { onselectstart: "return false" }
                                  },
                                  [
                                    _c(
                                      "b-form-checkbox",
                                      {
                                        attrs: {
                                          switch: "",
                                          disabled:
                                            _vm.configuredTableFieldsActive &&
                                            element.show
                                        },
                                        on: { input: _vm.saveTableConfig },
                                        model: {
                                          value: element.show,
                                          callback: function($$v) {
                                            _vm.$set(element, "show", $$v)
                                          },
                                          expression: "element.show"
                                        }
                                      },
                                      [
                                        _c("fup-icon", {
                                          staticClass: "text-muted mr-2 handle",
                                          class: _vm.$style.handle,
                                          attrs: { name: "sort" }
                                        }),
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(element.label) +
                                            "\n                            "
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              }),
                              0
                            )
                          : _vm._e()
                      ]
                    : _vm._e()
                ],
                2
              ),
              _vm._v(" "),
              _c("template", { slot: "footer" }, [
                _c(
                  "div",
                  { staticClass: "actions" },
                  [
                    _c("b-button", { on: { click: _vm.resetTableFields } }, [
                      _vm._v("Сбросить по умолчанию")
                    ]),
                    _vm._v(" "),
                    _c(
                      "b-button",
                      {
                        attrs: { variant: "warning" },
                        on: { click: _vm.closeTableConfigurator }
                      },
                      [_vm._v("Готово")]
                    )
                  ],
                  1
                )
              ])
            ],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }